import React from 'react';
import { CheckIcon, PlusIcon, StarIcon } from 'lucide-react';
import { Reveal } from '../ui/Reveal';
import { CtaButton } from '../ui/Button';
import { offers, TRUST_POINTS } from '../../data/offers';
export function Offers() {
  return <section id="ofertas" className="scroll-mt-4 bg-ink py-16 md:py-24" data-id="element-83" data-mp="3lukjf41qxkxd">
      <div className="mx-auto max-w-5xl px-5 md:px-8" data-id="element-84" data-mp="3hqct52fn3wx1">
        <Reveal data-id="element-85" data-mp="3hts721xkuzwv">
          <div className="text-center" data-id="element-86" data-mp="3vqxdi317e0sn">
            <h2 className="font-display text-2xl font-black uppercase leading-tight text-white sm:text-3xl md:text-[2.6rem]" data-id="element-87" data-mp="3vpvxrl98sq4l">
              Elegí cómo
              <span className="block text-gold" data-id="element-88" data-mp="9bcn9zne1v3e">querés empezar</span>
            </h2>
            <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-cream/65 md:text-lg" data-id="element-89" data-mp="9dfdajojjo84">
              Dos opciones. Un solo objetivo: empezar a llevar nuevos proyectos
              a tu taller.
            </p>
          </div>
        </Reveal>

        <div className="mt-10 grid gap-5 md:grid-cols-2 md:items-start" data-id="element-90" data-mp="deinoqntks1y">
          {offers.map((offer, index) => <Reveal key={offer.id} delay={index * 0.06} data-id="element-91" data-mp="eme4r2yb5qar" data-mpi={index}>
              <article className={`relative flex h-full flex-col rounded-2xl p-6 md:p-7 ${offer.highlight ? 'border-2 border-gold bg-ink-soft shadow-lift' : 'border border-ink-line bg-ink-soft/60'}`} data-id="element-92" data-mp="jiuuu2p2ieqh">
                {offer.badge && <span className="absolute -top-3 left-6 inline-flex items-center gap-1 rounded-full bg-gold px-3 py-1 font-display text-[10px] font-black uppercase tracking-wider text-ink" data-id="element-93" data-mp="xj5ofdhri7fc">
                    <StarIcon className="h-2.5 w-2.5 fill-ink" data-id="element-94" data-mp="17a0k18gwejdg" />
                    {offer.badge}
                  </span>}

                <p className="mt-1 font-display text-[10px] font-black uppercase tracking-[0.22em] text-gold" data-id="element-95" data-mp="1h7ohw79sw6zu">
                  {offer.name}
                </p>
                <h3 className="mt-2 font-display text-xl font-black uppercase leading-tight text-white md:text-2xl" data-id="element-96" data-mp="1l99s1kuya76c">
                  {offer.subtitle}
                </h3>

                <ul className="mt-5 space-y-2.5" data-id="element-97" data-mp="3dbuhnjmjkvnw">
                  {offer.includes.map(item => <li key={item} className="flex items-start gap-2.5 text-sm leading-snug text-cream/75" data-id="element-98" data-mp="3r2r9374qf6td">
                      <CheckIcon className="mt-0.5 h-4 w-4 flex-shrink-0 text-cta" strokeWidth={3.5} data-id="element-99" data-mp="4tyf0vu6ib7e" />
                      {item}
                    </li>)}
                </ul>

                {offer.extras && offer.extras.length > 0 && <ul className="mt-4 space-y-2.5 rounded-xl border border-gold/30 bg-gold/10 p-4" data-id="element-100" data-mp="9uca7daolqo0">
                    {offer.extras.map(item => <li key={item} className="flex items-start gap-2.5 text-sm font-semibold leading-snug text-gold-light" data-id="element-101" data-mp="2blh4kh4015c1">
                        <PlusIcon className="mt-0.5 h-4 w-4 flex-shrink-0" strokeWidth={3} data-id="element-102" data-mp="25im71oltoupt" />
                        {item}
                      </li>)}
                  </ul>}

                <div className="mt-auto pt-7" data-id="element-103" data-mp="1ht9pa0cfjebw">
                  {offer.oldPrice && <>
                      <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-cream/40" data-id="element-104" data-mp="1msw1c6giuoj4">
                        Valor total
                      </p>
                      <p className="mt-0.5 text-lg font-semibold line-through text-cream/40" data-id="element-105" data-mp="18uobsjltephz">
                        {offer.oldPrice}
                      </p>
                      <p className="mt-3 font-display text-[10px] font-black uppercase tracking-[0.2em] text-cta" data-id="element-106" data-mp="337nwus8ysbwn">
                        Hoy
                      </p>
                    </>}

                  <p className={`font-display font-black leading-none text-white ${offer.oldPrice ? 'mt-1' : 'mt-0'} text-4xl md:text-5xl`} data-id="element-107" data-mp="1824x3bb5kar7">
                    {offer.price}
                  </p>
                  <p className="mt-2.5 text-[10px] font-bold uppercase tracking-[0.2em] text-cream/45" data-id="element-108" data-mp="y74pqogquypg">
                    Pago único
                  </p>

                  <div className="mt-6" data-id="element-109" data-mp="p5dj9hedqnuj">
                    <CtaButton href={offer.url} data-id="element-110" data-mp="p6et5ijnt4ao">{offer.ctaLabel}</CtaButton>
                  </div>

                  <ul className="mt-4 flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5" data-id="element-111" data-mp="kc2d7ihe6b3o">
                    {TRUST_POINTS.map(point => <li key={point} className="flex items-center gap-1.5 text-[11px] font-medium text-cream/55" data-id="element-112" data-mp="ah0jsag32mva">
                        <CheckIcon className="h-3 w-3 text-cta" strokeWidth={3.5} data-id="element-113" data-mp="1g2ezpxtmbbn" />
                        {point}
                      </li>)}
                  </ul>
                </div>
              </article>
            </Reveal>)}
        </div>
      </div>
    </section>;
}